<script setup>
import OptionValue from "@/components/frontend/ui/OptionValue.vue";
import dayjs from "dayjs";
import { watch } from "vue";

const props = defineProps({
  slots: {
    type: Array,
    required: true,
  },
  selectedSlot: {
    type: Object,
  },
  disabled: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits([
  'slot-change'
]);
const onSlotChange = (slot) => {
  emit('slot-change', slot);
};

watch(
  () => props.slots,
  (newSlots) => {
    if (newSlots.length > 0) {
      const firstAvailableSlot = newSlots.find(slot => slot.availableEquipments.length > 0);
      if (firstAvailableSlot) {
        emit('slot-change', firstAvailableSlot);
      }
    }
  },
  { immediate: true }
)

</script>

<template>
  <OptionValue v-for="slot in slots"
               :key="slot.start_at"
               :option-value="slot.start_at"
               @change="onSlotChange(slot)"
               class="mb-2"
               :selected="selectedSlot?.start_at === slot.start_at && selectedSlot?.end_at === slot.end_at"
               :disabled="disabled || slot.availableEquipments.length === 0"
  >
    {{ dayjs(slot.start_at).format('LT') }}
    →
    {{ dayjs(slot.end_at).format('LT') }}
  </OptionValue>
</template>

<style scoped>

</style>